/**
 * Mapping for an attribute die from a number 1-6 to the die value
 * @param face The number rolled on a regular d6
 * @returns [value, assassin symbol]
 *  value: the amount added to the total roll
 *  assassin symbol: 1 if this result is an assassin symbol
 */
export const rollWhite = (face: number) => {
  switch (face) {
    case 1:
    case 2:
    case 3:
      return [0, 0];
    default:
      return [1, 0];
  }
};

/**
 * Mapping for a skill die from a number 1-6 to the die value
 * @param face The number rolled on a regular d6
 * @returns [value, assassin symbol]
 *  value: the amount added to the total roll
 *  assassin symbol: 1 if this result is an assassin symbol
 */
export const rollBlue = (face: number) => {
  switch(face)
  {
    case 1:
    case 2:
      return [0, 0];
    case 3:
      return [1, 1];
    case 4:
    case 5:
      return [1, 0];
    default:
      return [2, 0];
  }
}

/**
 * Mapping for a minor penalty die from a number 1-6 to the die value
 * @param face The number rolled on a regular d6
 * @returns [value, assassin symbol]
 *  value: the amount added to the total roll
 *  assassin symbol: 1 if this result is an assassin symbol
 */
export const rollRed = (face: number) => {
  switch(face)
  {
    case 1:
    case 2:
      return [0, 0];
    case 3:
      return [1, 1];
    default:
      return [-1, 0];
  }
}

/**
 * Mapping for a major penalty die from a number 1-6 to the die value
 * @param face The number rolled on a regular d6
 * @returns [value, assassin symbol]
 *  value: the amount added to the total roll
 *  assassin symbol: 1 if this result is an assassin symbol
 */
export const rollBlack = (face: number) => {
  switch(face)
  {
    case 1:
    case 2:
      return [0, 0];
    case 3:
    case 4:
    case 5:
      return [-1, 0];
    default:
      return [-2, 0];
  }
}